import React, { useState } from "react";
import Navbar from "../Navbar";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Typography,
} from "@mui/material";
import Footer from "../Footer";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import "./FAQ.scss";

const FAQ = () => {
  const FrequentlyAskedQuestions = {
    packagesAndPlans: [
      {
        question: "How can I buy a plan/package?",
        answer:
          "You can buy a plan/package from our website https://tron.health or simply call our customer care team on +91 7300002911, +91 9660099459.",
      },
      {
        question: "What are the inclusions under the Value plan?",
        answer:
          "Under the value plan, a subscriber/customer gets 15% flat discount on total treatment cost negotiated between the Service provider and the patient when the payments are made through our website. For a small subscription fees of Rs. 499 plus GST, one can avail benefits worth over Rs. 15,000 annually. This is an individual plan and single retail customers can sample our services at a cost less than what it costs to buy a pizza in many places. For more information call +91 7300002911, +91 9660099459 or simply buy the plan by clicking on the link. Additionally, our customers get great discounts on health check up packages and consultations.",
      },
      {
        question: "What are the inclusions under the Starter plan?",
        answer:
          "A plan just right for those wishing to sample our services, this is perhaps the cheapest plan on our network. For just Rs. 299 plus GST, you get complete access to our service provider network with more than 500 clinics and hospitals and furthermore, avail flat discount of 10% on your treatment over a year. This is an individual plan and retail customers can buy these.",
      },
      {
        question: "What are the inclusions under the Silver plan?",
        answer:
          "The first of our family plans, provides for discounts upto 30% on all treatments within our network of service providers. This is a group plan that is open for a family of 3 which must be blood relations linked to a single mobile number. For a price of Rs. 1,500 per person per annum, you can avail benefits upto Rs. 6,000 in a year. Additionally, we offer great discounts on all our health check up packages and diagnostics.",
      },
      {
        question: "What are the inclusions under the Gold plan?",
        answer:
          "The Gold plan is the first of our group plans that offers upto 40% discount on all treatment costs. To be eligible for this plan, the group must have at least 10 members of varying age brackets. For a per person annual subscription of just Rs. 2,000, the subscribers can avail benefits worth Rs. 8,000.",
      },
      {
        question: "What are the inclusions under the Diamond plan?",
        answer:
          "The Diamond plan aims to cut your OPD expenses to half with a very lucrative 50% discount on all treatment costs. To be eligible for this plan, the group must have at least 20 members of varying age brackets. For a per person annual subscription of just Rs. 2,500, the subscribers can avail benefits worth Rs. 10,000. These benefits extend to all services on treatments. Additionally, customers avail heavy discounts on diagnostics and health check up packages.",
      },
      {
        question: "What are the inclusions under the Platinum plan?",
        answer:
          "The Platinum plan is ideally meant for high risk individuals with frequent visits to the doctors, offering upto 60% discount on all treatment costs. To be eligible for this plan, the group must have at least 50 members of varying age brackets. Each subscriber can avail benefits worth Rs. 12,000 for a small subscription fees. Additionally, customers avail heavy discounts on diagnostics and health check up packages.",
      },
      {
        question: "What are the inclusions under the Super Saver plan?",
        answer:
          "The Super Saver plan is our top of the line offering meant for large health conscious group of customers, offering upto 70% discount on all treatment costs. To be eligible for this plan, the group must have at least 100 members of varying age brackets. Each subscriber can avail benefits worth Rs. 14,000 for a small subscription fees. Additionally, customers avail heavy discounts on diagnostics and health check up packages.",
      },
      {
        question:
          "Are there any special packages for corporates or large groups?",
        answer:
          "Yes, Tron.health offers great OPD plans and packages for corporates and large groups. Please get in touch with us on our mobile no. +91 7300002911, +91 9660099459 or email support@tron.health for custom made packages for large customer groups. We offer these plans for even smaller companies with as few as 20 employees. We believe besides helping take our country towards a focus on preventive care, this initiative is a great employee retention scheme. We are additionally able to offer our discount plans at a fraction of the per subscriber cost of our retail plans to our corporate customers.",
      },
      {
        question: "Can I cancel my plan/package?",
        answer:
          "Cancellation of a plan/package is not permitted. For more details, please reach out to us on our mobile number +91 7300002911, +91 9660099459.",
      },
      {
        question: "Are our plans/packages like insurance plans?",
        answer:
          "We are not an insurance company. We run only discount plans and packages on the lines as indicated above. We insist our customers to completely understand the limited liability that Tron carries in selling and servicing the plans and packages advertised by us.",
      },
      {
        question: "Can I gift a plan/package to someone?",
        answer:
          "Yes, you can gift a plan/package to anyone you like as long as the enclosed benefits are identifiable through a unique mobile number and the associated customer details.",
      },
      {
        question: "Can I transfer my plan/package to someone else?",
        answer: "We do not entertain transfer of plans/packages once bought.",
      },
      {
        question: "Can you offer us special plans for dental services?",
        answer:
          "Yes, we can offer custom made dental plans to our customers that can be serviced through our network of dental clinics. Please contact us on +91 7300002911, +91 9660099459. for further details or contact us at link.",
      },
      {
        question: "Can you offer us special plans for ENT services?",
        answer:
          "Yes, we can offer custom made ENT plans to our customers that can be serviced through our network of ENT hospitals and clinics. Please contact us on +91 7300002911, +91 9660099459. for further details or contact us at link.",
      },
      {
        question: "Can you offer us special plans for Ophthal services?",
        answer:
          "Yes, we can offer custom made Eye care plans to our customers that can be serviced through our network of Ophthal clinics. Please contact us on +91 7300002911, +91 9660099459. for further details or contact us at link.",
      },
      {
        question: "Can you offer us special plans for Gastro services?",
        answer:
          "Yes, we can offer custom made plans to our customers that can be serviced through our network of Gastroenterologists. Please contact us on +91 7300002911, +91 9660099459. for further details or contact us at link.",
      },
      {
        question: "Can you offer us special plans for Gynaec services?",
        answer:
          "Yes, we can offer custom made plans to our customers that can be serviced through our network of Gynaecologists. Please contact us on +91 7300002911, +91 9660099459. for further details or contact us at link.",
      },
      {
        question: "Can I order health check up for me and my family?",
        answer:
          "Yes, you can order for health check ups through our website and enjoy great discounts on our services.",
      },
      {
        question: "Can I get consultation services as part of the plan?",
        answer: "Yes, consultations are included in all our plans. ",
      },
    ],
    Payment: [
      {
        question: "What is the refund policy?",
        answer:
          "Typically, refunds after the treatment has been carried out are not possible. Refunds within 7 days of buying a plan prior to using any services of Tron may be considered for refund if validated with a genuine reason. Group plans once bought cannot be refunded at all.",
      },
      {
        question: "Is any financial assistance available?",
        answer:
          "We may be able to offer some financing schemes through third party vendors on our website subject to eligibility of the customer. For the same, we may require certain documents of the customers.",
      },
      {
        question: "What payment methods are acceptable at Tron?",
        answer:
          "Tron accepts all forms of payments including but not limited to UPI, all cards and netbanking.",
      },
      {
        question:
          "What should I do if my payment is deducted but the plan or package is not booked?",
        answer:
          "In such scenario please confirm about the payment and contact our customer care at +91 7300002911, +91 9660099459. or contact is at link.",
      },
      {
        question: "What are benefits of continuing long with Tron?",
        answer:
          "Tron offers no claim bonus on your plans that allows for lower subscription costs from the following year if the same/higher plan is carried forward to the following years. Additionally, Tron offers loyalty discounts to our customers. We are also able to offer additional discounts on treatments in select cases so a customer is all set to benefit from Tron’s services in multiple ways.",
      },
    ],
    ClinicsAndHospitals: [
      {
        question:
          "What will be the procedure followed at the clinic or hospital?",
        answer:
          "The customer is expected to buy a plan subscription in case of doctor consultations first. For the utilisation of the same, the customer can book an appointment through our website or by calling our customer care at +91 7300002911, +91 9660099459. At the clinic, the customer must arrive a little before the time of the appointment. Tron will make every effort that the customer is seen as per the appointment time. There may be a few situations where the customer may have to wait a little. The customer will be consulted by the doctor and a treatment plan shared with the customer. The customer can choose to proceed with the treatment or may choose to undergo treatment at a later time. Post the treatment, the customer must pay for the discounted part of the treatment cost. To enjoy full benefits, we encourage our customers to pay for their treatments through the Tron application only.",
      },
      {
        question: "Is a guarantee offered on the treatment?",
        answer:
          "Treatment guarantees can only be offered if at all by the treating doctor. The customers and patients are encouraged to discuss this with the doctor before proceeding with the treatment. Tron does not take any responsibility of the quality of the treatment carried out by the doctors. Tron does make an effort to onboard doctors and clinics of repute but the final responsibility of the quality of the treatment lies entirely with the clinics and the doctors.",
      },
      {
        question: "Will I pay each time at the clinic or hospital?",
        answer:
          "You will be required to pay for the part of the treatment carried out every time before or after the treatment. The same will be conveyed to you as part of the treatment planning. Please note, Tron offers discounts on services only. Fitment of certain devices or implants as part of the treatment may not be discounted under our plans.",
      },
      {
        question: "How can I book an appointment?",
        answer:
          "You can book a doctor consultation through our website by clicking the link or calling our customer care team on +91 7300002911, +91 9660099459.",
      },
      {
        question: "Can I choose my doctor or clinic?",
        answer:
          "Yes, you can choose from our wide list of available doctors and specialities using our website.",
      },
      {
        question: "Can I reschedule/cancel my appointment?",
        answer:
          "One rescheduling/cancellation of appointment is permitted provided it is done in good time. We request our customers to inform either us or the clinic in time to avoid embarrassment. We do encourage our customers to respect the doctor’s time when an appointment has been finalised.",
      },
      {
        question:
          "If I shift from the city I am in, how can I use my plan/package?",
        answer:
          "You can continue to use our services wherever these are available even if you change cities. Please do ascertain whether our services are available in the new city you are moving to though.",
      },
    ],
    KnowledgeCenter: [
      {
        question: "How can I become a part of Tron.Health?",
        answer1:
          "As a customer, you can become a part of Tron Healthcare by simply registering on our website. As a collaborator, please reach out to us, we may have some exciting plans for you.",
        answer2:
          "If you are a healthcare player, who may be looking to partner us, please feel free to reach out to us.",
      },
      {
        question:
          "As a clinic/hospital, how can I become part of Tron network?",
        answer1:
          "In case you are a clinic/hospital that would like to join our panel of eminent service providers, please reach out to us through either our customer care at +91 7300002911, +91 9660099459. or email us at support@tron.health.",
      },
    ],
  };

  const [expanded, setExpanded] = useState("panel0");
  const [paymentExpand, setPaymentExpand] = useState("");
  const [clinicExpand, setClinicExpand] = useState("");
  const [knowledgeCenter, setKnowledgeCenter] = useState("");
  const handleChange = (panel, section) => (event, isExpanded) => {
    if (section === "packagesAndPlans") {
      setExpanded(isExpanded ? panel : false);
    }
    if (section === "payment") {
      setPaymentExpand(isExpanded ? panel : false);
    }
    if (section === "clinicsAndHospitals") {
      setClinicExpand(isExpanded ? panel : false);
    }
    if (section === "knowledgeCenter") {
      setKnowledgeCenter(isExpanded ? panel : false);
    }
  };

  const parseTextWithLinks = (text) => {
    const emailRegex = /([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})/g;
    const phoneRegex = /(\+91\s?\d{10})/g;
    const urlRegex = /(https?:\/\/[^\s]+)/g;

    const formatted = text
      .replace(
        urlRegex,
        '<a href="$1" target="_blank" rel="noopener noreferrer" style="color:#1a0655;">$1</a>'
      )
      .replace(emailRegex, '<a href="mailto:$1" style="color:#1a0655;">$1</a>')
      .replace(phoneRegex, '<a href="tel:$1" style="color:#1a0655;">$1</a>');

    return (
      <span
        className="parsed-links"
        dangerouslySetInnerHTML={{ __html: formatted }}
      />
    );
  };
  return (
    <div className="FaqMainDiv">
      <Navbar />
      <Box className="faqMainbody">
        <Typography variant="h5">Frequently Asked Questions</Typography>
        <Box className="accordionBox">
          <Box className="PackagesAndPlansBox">
            <Typography variant="h6" className="heading">
              Packages & Plans
            </Typography>

            {FrequentlyAskedQuestions?.packagesAndPlans?.map((item, index) => {
              const isActive = expanded === `panel${index}`;
              return (
                <Accordion
                  key={index}
                  expanded={isActive}
                  onChange={handleChange(`panel${index}`, "packagesAndPlans")}
                  sx={{
                    mb: isActive ? "0" : "8px",
                    borderRadius: "8px",
                    boxShadow: "none",
                    border: "1px solid #ddd",
                    overflow: "hidden",
                    transition: "all 0.4s ease-in-out",
                  }}
                >
                  <AccordionSummary
                    sx={{
                      bgcolor: "#f5f5f5",
                      // "&.Mui-expanded": {
                      //   minHeight: "48px",
                      // },
                      "& .MuiAccordionSummary-content.Mui-expanded": {
                        margin: "0px",
                      },
                      py: 1,
                      margin: 0,
                    }}
                    expandIcon={<ExpandMoreIcon />}
                  >
                    <Typography className="question">
                      {index + 1}. {item.question}
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails sx={{ py: 1.5, px: 2 }}>
                    <Typography variant="body2" className="answer">
                      {parseTextWithLinks(item.answer)}
                    </Typography>
                  </AccordionDetails>
                </Accordion>
              );
            })}
          </Box>

          <Box className="Payment">
            <Typography variant="h6" className="heading">
              Payment
            </Typography>
            {FrequentlyAskedQuestions?.Payment?.map((item, index) => {
              const isActive = paymentExpand === `panel${index}`;
              return (
                <Accordion
                  key={index}
                  expanded={isActive}
                  onChange={handleChange(`panel${index}`, "payment")}
                  sx={{
                    mb: "8px",
                    borderRadius: "8px",
                    boxShadow: "none",
                    border: "1px solid #ddd",
                    overflow: "hidden",
                    transition: "all 0.3s ease-in-out",
                  }}
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1-content"
                    id="panel1-header"
                    sx={{
                      bgcolor: "#f5f5f5",
                      // "&.Mui-expanded": {
                      //   minHeight: "48px",
                      // },
                      "& .MuiAccordionSummary-content.Mui-expanded": {
                        margin: "0px",
                      },
                      py: 1,
                      margin: 0,
                    }}
                  >
                    <Typography className="question">
                      {" "}
                      {index + 1}. {item.question}
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails sx={{ py: 1.5, px: 2 }}>
                    <Typography variant="body2" className="answer">
                      {parseTextWithLinks(item.answer)}
                    </Typography>
                  </AccordionDetails>
                </Accordion>
              );
            })}
          </Box>

          <Box className="ClinicsAndHospitals">
            <Typography variant="h6" className="heading">
              Clinics And Hospitals
            </Typography>
            {FrequentlyAskedQuestions?.ClinicsAndHospitals?.map(
              (item, index) => {
                const isActive = clinicExpand === `panel${index}`;
                return (
                  <Accordion
                    key={index}
                    expanded={isActive}
                    onChange={handleChange(
                      `panel${index}`,
                      "clinicsAndHospitals"
                    )}
                    sx={{
                      mb: "8px",
                      borderRadius: "8px",
                      boxShadow: "none",
                      border: "1px solid #ddd",
                      overflow: "hidden",
                      transition: "all 0.3s ease-in-out",
                    }}
                  >
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel1-content"
                      id="panel1-header"
                      sx={{
                        bgcolor: "#f5f5f5",
                        // "&.Mui-expanded": {
                        //   minHeight: "48px",
                        // },
                        "& .MuiAccordionSummary-content.Mui-expanded": {
                          margin: "0px",
                        },
                        py: 1,
                        margin: 0,
                      }}
                    >
                      <Typography f className="question">
                        {" "}
                        {index + 1}. {item.question}
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails sx={{ py: 1.5, px: 2 }}>
                      <Typography variant="body2" className="answer">
                        {parseTextWithLinks(item.answer)}
                      </Typography>
                    </AccordionDetails>
                  </Accordion>
                );
              }
            )}
          </Box>

          <Box className="KnowledgeCenter">
            <Typography variant="h6" className="heading">
              Knowledge Center
            </Typography>
            {FrequentlyAskedQuestions?.KnowledgeCenter?.map((item, index) => {
              const isActive = knowledgeCenter === `panel${index}`;
              return (
                <Accordion
                  key={index}
                  expanded={isActive}
                  onChange={handleChange(`panel${index}`, "knowledgeCenter")}
                  sx={{
                    mb: "8px",
                    borderRadius: "8px",
                    boxShadow: "none",
                    border: "1px solid #ddd",
                    overflow: "hidden",
                    transition: "all 0.3s ease-in-out",
                  }}
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1-content"
                    id="panel1-header"
                    sx={{
                      bgcolor: "#f5f5f5",
                      // "&.Mui-expanded": {
                      //   minHeight: "48px",
                      // },
                      "& .MuiAccordionSummary-content.Mui-expanded": {
                        margin: "0px",
                      },
                      py: 1,
                      margin: 0,
                    }}
                  >
                    <Typography className="question">
                      {" "}
                      {index + 1}. {item.question}
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails sx={{ py: 1.5, px: 2 }}>
                    <Typography variant="body2" className="answer">
                      {parseTextWithLinks(item?.answer1)}
                    </Typography>
                    {item.answer2 && (
                      <Typography variant="body2" className="answer">
                        {parseTextWithLinks(item?.answer2)}
                      </Typography>
                    )}
                  </AccordionDetails>
                </Accordion>
              );
            })}
          </Box>
        </Box>
      </Box>
      <Footer />
    </div>
  );
};

export default FAQ;
